import { generateObjectZeroId, restEmpty, simpleAlert } from "components/CommonLib/CommonLib";
import Navbar from "components/NavMenu/Navbar";
import { permissionInitData } from "components/Panels/permissionInitData";
import Sidebar from "components/Sidebar/Sidebar";
import { HttpInstance, RefreshPublicIpHeader } from "lib/HttpLib";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { SetAuthTokens } from "../../lib/HttpLib";
import { getAuthInfoStores } from "../../modules/actions/Auth/index";

const PrivateRoute = ({ auth_info }) => {
  const storesDispatch = useDispatch();
  const navigate = useNavigate();
  const [permissionState, setPermissionState] = useState(permissionInitData);

  useEffect(() => {
    getAuthData();
  }, []);

  // 권한에 따른 메뉴 검증
  const getAuthData = async () => {
    try {
      await RefreshPublicIpHeader();

      const permData = await HttpInstance.get(
        process.env.REACT_APP_AUTH_SERVER + "/global/perm_auth",
        {},
      );
      if (!restEmpty(permData.data.data)) {
        //
        // TEMPORAL AUTH. (실적관리 권한 = 급여관리 권한)
        //
        if (permData.data.data && permData.data.data.side_menu.branch_menu.children) {
          const vaultCashMenu = {
            menu_title: "시재금 관리",
            menu_url: "/vault_cash",
            menu_active:
              permData.data.data.side_menu.branch_menu.children.find(
                (menu) => menu.menu_title === "운영일지",
              )?.menu_active ?? false,
            children: [],
          };
          const dailyReportIndex = permData.data.data.side_menu.branch_menu.children.findIndex(
            (menu) => menu.menu_title === "운영일지",
          );

          if (dailyReportIndex !== -1) {
            // "운영일지" 다음 위치에 삽입
            permData.data.data.side_menu.branch_menu.children.splice(
              dailyReportIndex + 1,
              0,
              vaultCashMenu,
            );
          } else {
            permData.data.data.side_menu.branch_menu.children.push(vaultCashMenu);
          }

          const branchMenuList = permData.data.data.side_menu.branch_menu.children;
          const salaryIdx = branchMenuList.findIndex((x) => x.menu_title === "급여 관리");
          if (salaryIdx !== -1) {
            if (branchMenuList[salaryIdx].menu_active) {
              const recordIdx = branchMenuList.findIndex((x) => x.menu_title === "실적관리");
              if (recordIdx !== -1) {
                branchMenuList[recordIdx].menu_active = true;
              }
            }
          }
        }

        //
        // StaffInfo를 가져와서 permData에 staffName을 추가해준다 (환영메시지에 이름 띄우기 위함)
        //
        const staffId = permData.data.data.staff_id;
        let staffName = "";
        let authId = "";
        if (permData.data.data.staff_id === generateObjectZeroId()) {
          if (permData.data.data.is_admin) {
            staffName = "관리자";
            authId = "admin";
          }
        } else {
          if (staffId) {
            const staffInfo = await HttpInstance.get(
              process.env.REACT_APP_STAFF_SERVER + "/staff/get_staff_info",
              {
                params: {
                  staff_id: staffId,
                },
              },
            );
            if (!restEmpty(staffInfo.data.data)) {
              staffName = staffInfo.data.data.contents.staff_obj.personal_info.staff_name;
              authId = staffInfo.data.data.contents.auth_id;
            }
          }
        }
        permData.data.data.staff_name = staffName;
        permData.data.data.auth_id = authId;
        setPermissionState(permData.data.data);
      }
    } catch (err) {
      simpleAlert(
        storesDispatch,
        "알림",
        err.response.data ? err.response.data.msg : err.code,
        true,
        () => {
          navigate("/login");
        },
      );
    }
  };

  // 로그인 인증 여부
  const auth = () => {
    if (auth_info.stores === undefined) {
      return false;
    }
    if (auth_info.stores === null) {
      return false;
    }
    if (auth_info.stores.auth_info !== undefined) {
      if (auth_info.stores.auth_info.stores === null) {
        return false;
      }
    }

    SetAuthTokens(auth_info.stores);

    return true;
  };

  const retAuth = auth();

  return retAuth ? (
    <>
      <Navbar permissionState={permissionState} />
      <Sidebar permissionState={permissionState} />
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

function mapStateToProps(state) {
  return {
    auth_info: state.auth_info,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAuthStore: () => dispatch(getAuthInfoStores()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
